var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { GraphQLNonNegativeInt, GraphQLPositiveInt } from "graphql-scalars";
import { ArgsType, Field, InputType, ObjectType } from "type-graphql";
import { FilteredListQueryArgs } from "../filtering/FilteredListQueryArgs.js";
import { DeviceNode } from "../resources/Device.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { AbstractGraphQLPaginatedResponse } from "./PaginatedResponse.js";
let GetDeviceByUuidResponse = class GetDeviceByUuidResponse {
    data;
};
__decorate([
    Field(() => DeviceNode, { nullable: false }),
    __metadata("design:type", DeviceNode)
], GetDeviceByUuidResponse.prototype, "data", void 0);
GetDeviceByUuidResponse = __decorate([
    ObjectType("GetDeviceByUuidResponse")
], GetDeviceByUuidResponse);
export { GetDeviceByUuidResponse };
let ListDevicesResponse = class ListDevicesResponse extends AbstractGraphQLPaginatedResponse {
    data;
};
__decorate([
    Field(() => [DeviceNode], { nullable: false }),
    __metadata("design:type", Array)
], ListDevicesResponse.prototype, "data", void 0);
ListDevicesResponse = __decorate([
    ObjectType("ListDevicesResponse", {
        implements: (AbstractGraphQLPaginatedResponse),
    })
], ListDevicesResponse);
export { ListDevicesResponse };
let RegisterDeviceResponse = class RegisterDeviceResponse {
    ok;
    data;
};
__decorate([
    Field(() => Boolean, { nullable: false }),
    __metadata("design:type", Boolean)
], RegisterDeviceResponse.prototype, "ok", void 0);
__decorate([
    Field(() => DeviceNode, { nullable: false }),
    __metadata("design:type", DeviceNode)
], RegisterDeviceResponse.prototype, "data", void 0);
RegisterDeviceResponse = __decorate([
    ObjectType("RegisterDeviceResponse")
], RegisterDeviceResponse);
export { RegisterDeviceResponse };
let RegisterDeviceInput = class RegisterDeviceInput {
    deviceId;
    expoPushToken;
    verifier;
    lastUserId;
};
__decorate([
    Field(() => String, {
        description: "For legacy reasons, this can be a GlobalId or a raw UUID",
        nullable: false,
    }),
    __metadata("design:type", String)
], RegisterDeviceInput.prototype, "deviceId", void 0);
__decorate([
    Field(() => String, {
        description: "The Expo push token of the device",
        nullable: true,
    }),
    __metadata("design:type", Object)
], RegisterDeviceInput.prototype, "expoPushToken", void 0);
__decorate([
    Field(() => String, {
        description: "base64 encoded SHA-256 hash of a secret known to the device",
        nullable: false,
    }),
    __metadata("design:type", String)
], RegisterDeviceInput.prototype, "verifier", void 0);
__decorate([
    Field(() => GlobalIdScalar, {
        description: "The ID of the last user to log in on this device",
        nullable: true,
    }),
    __metadata("design:type", Object)
], RegisterDeviceInput.prototype, "lastUserId", void 0);
RegisterDeviceInput = __decorate([
    InputType()
], RegisterDeviceInput);
export { RegisterDeviceInput };
let ListDevicesArgs = class ListDevicesArgs extends FilteredListQueryArgs("DeviceResolver", [
    "lastLogin",
    "lastLoggedInUserName",
    "lastLoggedInUserEmail",
    "createdAt",
    "updatedAt",
]) {
};
ListDevicesArgs = __decorate([
    ArgsType()
], ListDevicesArgs);
export { ListDevicesArgs };
let NotificationDeliveriesArgs = class NotificationDeliveriesArgs {
    // TODO: Handle this in the normal authorization flow instead of here
    verifier;
    page;
    pageSize;
};
__decorate([
    Field(() => String, {
        nullable: true,
        description: "The verifier code for this device, if it does not match then the query will be rejected",
    }),
    __metadata("design:type", String)
], NotificationDeliveriesArgs.prototype, "verifier", void 0);
__decorate([
    Field(() => GraphQLPositiveInt, { nullable: true, defaultValue: 1 }),
    __metadata("design:type", Number)
], NotificationDeliveriesArgs.prototype, "page", void 0);
__decorate([
    Field(() => GraphQLNonNegativeInt, { nullable: true, defaultValue: 10 }),
    __metadata("design:type", Number)
], NotificationDeliveriesArgs.prototype, "pageSize", void 0);
NotificationDeliveriesArgs = __decorate([
    ArgsType()
], NotificationDeliveriesArgs);
export { NotificationDeliveriesArgs };
//# sourceMappingURL=deviceParams.js.map